module.exports = __webpack_public_path__ + "static/media/8.6fd88420.webp";